module.exports = __webpack_public_path__ + "img/4063b56.svg";